import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import Anchor from '../Anchor';
import Theme from '../../theme';

import IconAvatar from '../../assets/svgs/avatar.svg';

const AvatarContainer = styled.div`
  position: relative;
`;

const SCCenteredAnchor = styled(Anchor)`
  display: flex;
  align-items: center;
`;

const AvatarMenuContainer = styled.div`
  top: ${remCalc(40)};
  right: ${remCalc(-15)};
  width: ${remCalc(180)};

  border: 2px solid ${Theme.colours.grey_e5};
  margin-top: ${remCalc(12)};
  border-radius: 3px;
  box-shadow: 0 -5px 5px -3px ${Theme.colours.grey_e5};
  position: absolute;
  z-index: 9999;
  overflow-x: visible;

  &::before {
    position: absolute;
    width: 0;
    height: 0;
    content: '';
    border-style: solid;
    border-color: transparent transparent ${Theme.colours.grey_e5} transparent;
    border-width: 0 10px 10px 10px;
    right: 22px;
    top: -11px;
  }
`;

const AvatarMenuList = styled.ul`
  z-index: 10;
  border-radius: 1px;
  list-style-type: none;
  margin: 0;
  display: block;
  background: ${Theme.colours.white};
  overflow: hidden;
  padding-left: 0;
`;

const AvatarMenuListItem = styled.li`
  margin: 0;
  padding: 0;

  &:hover {
    background: ${Theme.colours.grey_f5};
  }
`;

const AvatarMenuListItemAnchor = styled(Anchor)`
  padding: ${remCalc(9)} ${remCalc(20)};
  display: block;
  color: ${Theme.colours.black};
  text-decoration: none;

  &:not([disabled]):hover {
    color: ${Theme.colours.black};
  }
`;

class Avatar extends React.PureComponent {
  state = {
    isMenuOpen: false
  };

  handleClick = () => {
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen
    }));
  };

  render() {
    const { menu } = this.props;
    const { isMenuOpen } = this.state;
    return (
      <AvatarContainer>
        <SCCenteredAnchor onClick={this.handleClick}>
          <IconAvatar size={38} />
        </SCCenteredAnchor>
        {isMenuOpen && (
          <AvatarMenuContainer>
            <AvatarMenuList>
              {menu.map((menu, key) => (
                <AvatarMenuListItem key={key}>
                  <AvatarMenuListItemAnchor
                    secondary
                    onClick={menu.onClick}
                    href={menu.href}
                  >
                    {menu.title}
                  </AvatarMenuListItemAnchor>
                </AvatarMenuListItem>
              ))}
            </AvatarMenuList>
          </AvatarMenuContainer>
        )}
      </AvatarContainer>
    );
  }
}

export default Avatar;
